const REGULAR_MODULE_TYPE = 'topItem';
const BANNER_MODULE_TYPE = 'topItemBanner';
const ICONIC_DESIGN_MODULE_TYPE = 'topItemIconicDesign';
const BANNER_TILES_MODULE_TYPE = 'topItemBannerTiles';
const LANDING_MODULE_TYPE = 'topItemLanding';
const STORYTELLING_MODULE_TYPE = 'topItemStorytelling';

export {
    REGULAR_MODULE_TYPE,
    BANNER_MODULE_TYPE,
    ICONIC_DESIGN_MODULE_TYPE,
    BANNER_TILES_MODULE_TYPE,
    LANDING_MODULE_TYPE,
    STORYTELLING_MODULE_TYPE,
};
